import { type SignUpStoryblok } from '~/types/generated'
import { mapRichText } from '../SignUpForm/SignUpForm.mapping'
import { type ConfirmSignUpProps } from './ConfirmSignUp'

export const mapConfirmSignUp = (story: SignUpStoryblok): ConfirmSignUpProps => ({
  title: story.title,
  text: mapRichText(story.introText),
  confirmationText: mapRichText(story.confirmationText),
  confirmationTitle: story.confirmationTitle,
  linkText: story.linkText
})
